import { BCA, CRA, PCR } from "../app-consts/appConstants";

export const isABGPartner = (partnerCode = "") => [BCA, CRA, PCR].includes(partnerCode);
